var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeadStatusesPage',{attrs:{"title":`${_vm.__('autonomia', 'settings')} - ${_vm.__('unidades', 'settings')}`,"description":`${_vm.__(
    'define os status que são considerados ativos para a unidade.',
    'settings'
  )}
  ${_vm.__(
    'esses status são utilizados para definir a carga de serviços',
    'settings'
  )}`,"param-id":"lead_statuses_active_for_unity"}})
}
var staticRenderFns = []

export { render, staticRenderFns }